import { render, staticRenderFns } from "./CartaoOrdemDePagamento.vue?vue&type=template&id=24e5c1d3&scoped=true"
import script from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoOrdemDePagamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoOrdemDePagamento.vue?vue&type=style&index=0&id=24e5c1d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5c1d3",
  null
  
)

export default component.exports